import React, { useState, useEffect } from 'react';
import { Search } from 'lucide-react';
import { useCepLookup } from '../../hooks/useCepLookup';
import Input from '../ui/Input';
import Button from '../ui/Button';
import LoadingSpinner from '../ui/LoadingSpinner';

export default function CepAutoFill({ onAddress, value, onChange, ...props }) {
  const [internalCep, setInternalCep] = useState(value || '');
  const { data, loading, error, fetchCep } = useCepLookup();

  // Sincronizar com valor externo
  useEffect(() => {
    if (value !== undefined) {
      setInternalCep(value);
    }
  }, [value]);

  const handleChange = (e) => {
    const newValue = e.target.value;
    setInternalCep(newValue);
    
    if (onChange) {
      onChange(e);
    }
  };

  // Função para buscar CEP manualmente
  const handleSearchCep = () => {
    const cleanCep = internalCep.replace(/\D/g, '');
    if (cleanCep.length === 8) {
      fetchCep(cleanCep);
    }
  };

  // Chamar onAddress quando encontrar dados
  useEffect(() => {
    if (data && onAddress && !loading) {
      onAddress(data);
    }
  }, [data, loading]);
  return (
    <div className="space-y-2">
      <div className="relative">
        <Input
          value={internalCep}
          onChange={handleChange}
          placeholder="00000-000"
          maxLength={9}
          className="pr-12"
          {...props}
        />        <button
          type="button"
          onClick={handleSearchCep}
          disabled={loading || internalCep.replace(/\D/g, '').length !== 8}
          className="absolute right-3 top-9 p-1 text-gray-400 hover:text-blue-600 disabled:text-gray-300 disabled:cursor-not-allowed transition-colors flex items-center justify-center"
          title="Buscar CEP"
        >
          {loading ? (
            <LoadingSpinner size="sm" />
          ) : (
            <Search className="w-4 h-4" />
          )}
        </button>
      </div>
      
      {error && (
        <p className="text-red-500 text-xs">{error}</p>
      )}
      
      {data && !loading && (
        <div className="text-xs text-green-600 mt-1 p-2 bg-green-50 rounded-md border border-green-200">
          <strong>Endereço encontrado:</strong><br />
          {data.street} {data.neighborhood && `- ${data.neighborhood}`}<br />
          {data.city} - {data.state}
        </div>
      )}
    </div>
  );
}
